import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-general-size-icon',
  templateUrl: './general-size.component.html'
})
export class GeneralSizeComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
